/*
 * @format
 */

// Cognito answers UserLambdaValidationException when a trigger throws, and
// UnexpectedLambdaException when one runs past Cognito's time limit.
const TRIGGER_FAILED = [
  'UserLambdaValidationException',
  'UnexpectedLambdaException',
];

/**
 * Whether finishing a password reset failed in a Cognito trigger, e.g. the one
 * that removes the account's passkeys. Cognito has most likely saved the new
 * password by then, so the apps say it may already work.
 */
export const resetTriggerFailed = err => TRIGGER_FAILED.includes(err?.name);

/**
 * The password was reset, but signing in with the new one then failed
 * (`cause`, if given, says why). Kept apart from the reset's own failures, so
 * the screens say the reset worked rather than invite a retry with a code now
 * used up, and a sign-in trigger failing then isn't taken for the reset not
 * finishing. Shared by the app and the web app.
 */
export class SignInAfterResetError extends Error {
  constructor(cause) {
    super('Signing in after the password reset failed');
    this.name = 'SignInAfterResetError';
    this.cause = cause;
  }
}
